import _ from 'lodash';

export const selectValidation = state => _.get(state, ['validation'], {});
